import { Component, ViewEncapsulation, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { language, color, date } from 'curvy';
import { date_time_translations } from './date-time-picker.trans';


function switch_to_next_input(val: string, max: number, targetEl: HTMLInputElement) {
    // max is input value on which is expected to be switched on to the next input

    if (parseFloat(val) > max) {
        targetEl.focus();
        targetEl.value = targetEl.value = '';
    } else if (val.toString().length > 1) {
        targetEl.focus();
        targetEl.value = targetEl.value = '';
    }

}

function date_is_valid(date: Date): boolean {
    let num = +date;
    return num === num;
}



@Component({
    selector: 'task-time-picker',
    template: `
		<div class="flex-row justify-center time-picker-header" style="gap: 1em;" (keyup.enter)="handle_enter()">
			<label class="input outlined" [title]="'HOUR' | trans">
				<input placeholder="00"
					class="time-input"
					type="number"
					max="23"
					min="0"
					constrain
					integer
					[(ngModel)]="picked_hour"
					(blur)="date_to_emit()"
					(input)="switch_to_next(hourInput.value,2,minuteInput);"
					#hourInput>
				</label>

			:
			<label class="input outlined" [title]="'MINUTE' | trans">
				<input placeholder="00"
					class="time-input"
					type="number"
					max="59"
					min="0"
					constrain
					integer
					[(ngModel)]="picked_minute"
					(blur)="date_to_emit()"
					#minuteInput>

			</label>
		</div>
		`,
    styleUrls: ['./date-time-picker.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TimePickerComponent {
    // @ViewChild('timepicker') picker;
    // picked_hour: number = new Date().getHours();
    // picked_minute: number = new Date().getMinutes();
    picked_hour: number = NaN;
    picked_minute: number = NaN;
    picked_time: Date = null;
    picked_date: Date = null;
    tzoff = 0;

    switch_to_next = switch_to_next_input;

    @Input()
    get in_datetime() {
        return this.picked_date;
    }


    set in_datetime(val: Date | string | null) {
        if (typeof (val) === 'string') val = new Date(val);
        if (val == null) val = new Date();
        if (!date_is_valid(val)) return;

        let planned_datetime = val;

        this.tzoff = planned_datetime.getTimezoneOffset();

        planned_datetime = date.add(planned_datetime, date.duration({ minute: -this.tzoff }));

        let planned_date = date.start_of_day(planned_datetime, true);
        let planned_time = date.subtract(planned_datetime, planned_date);
        this.picked_date = planned_date;
        this.picked_time = planned_time;


        this.picked_hour = date.parts(planned_time, true).hour;
        this.picked_minute = date.parts(planned_time, true).minute;

    }

    @Output()
    in_datetimeChange = new EventEmitter<Date>();

    @Output('submit_date')
    submit_date = new EventEmitter<void>();

    date_to_emit() {
        console.log("DATE TO EMIT")
        this.picked_time = date.duration({ hour: this.picked_hour, minute: this.picked_minute });

        let planned_datetime = date.add(this.picked_date, this.picked_time);
        planned_datetime = date.add(planned_datetime, date.duration({ minute: this.tzoff }));

        this.picked_date = planned_datetime;

        this.in_datetimeChange.emit(this.picked_date);


    }


    ngOnInit() {
        language.load_translations(date_time_translations);
    }

    handle_enter() {
        this.date_to_emit();
        this.submit_date.emit();
    }
}
